import { Select, Input } from 'antd'

const MessageRibbon = ({
  filterValue,
  setFilterValue,
}) => {
  let statusItems = [
    {
      value: 0,
      label: '全部'
    },
    {
      value: 1,
      label: '待回复'
    },
    {
      value: 2,
      label: '已回复'
    }
  ]

  const clickStatusFilter = (value) => {
    setFilterValue({ ...filterValue, status: value })
  }

  const clickSearch = (value) => {
    setFilterValue({ ...filterValue, keywords: value })
  }

  return (
    <div className='ribbon-page'>
      <div className='ribbon-container'>
        <Select
          placeholder="留言状态"
          options={statusItems}
          style={{height: '32px', width: '200px'}}
          onChange={(value) => clickStatusFilter(value)}
        />
        <Input.Search
          placeholder="搜索留言内容"
          allowClear
          onSearch={clickSearch}
          style={{height: '32px', width: '240px'}}
        />
      </div>
    </div>
  )
}

export default MessageRibbon
